import { BYOD_DEVICE_LOCKED_CODES, BYOD_INCOMPATIBLE_CODES, BYOD_LOST_STOLEN_CODE, BYOD_SOFTWARE_INCOMPATIBLE_CODES, ByodEligibleStatus, SimType } from 'my-account/constants';
import { ModelBase } from 'store/model-base';


export class EligibilityByodStatus extends ModelBase {
    public static storeName: string = 'eligibilityByodStatus';

    public requestStatus: string;
    public deviceEligibilityResult: string;
    public denialReasons: EligibilityReason[];
    public eligibleImei: string;
    public supportedSimType: string;
    public deviceSku: string;
    public deviceLockStatus: string;
    public deviceProductDetails: ByodDeviceProductDetails;

    public isIncompatible: boolean;
    public isDeviceCompatible: boolean;
    public isDeviceNotCompatible: boolean;
    public isDeviceLocked: boolean;
    public isDevicePotentiallyLocked: boolean;
    public isDeviceEsimCompatible: boolean;
    public isDevicePsimCompatible: boolean;
    public isUpdateSoftwareCompatible: boolean;
    public isLostStolen: boolean;
    public isDeviceEligibilityError: boolean;

    public static create<T extends ModelBase>(initData: object = {}): T {
        const toReturn: EligibilityByodStatus = super.create<EligibilityByodStatus>(initData);
        if (!toReturn.denialReasons) {
            toReturn.denialReasons = [];
        }

        toReturn.isDeviceCompatible = toReturn.deviceEligibilityResult === ByodEligibleStatus.ELIGIBLE && !toReturn.denialReasons.length;
        toReturn.isDeviceNotCompatible = toReturn.deviceEligibilityResult === ByodEligibleStatus.NOT_ELIGIBLE;
        toReturn.isDeviceEsimCompatible = toReturn.isDeviceCompatible && toReturn.supportedSimType === SimType.ESIM;
        toReturn.isDevicePsimCompatible = toReturn.isDeviceCompatible && toReturn.supportedSimType === SimType.PSIM;
        toReturn.isDeviceLocked = toReturn.deviceLockStatus === 'LOCKED' || toReturn.denialReasons.some((reason: EligibilityReason) => BYOD_DEVICE_LOCKED_CODES.includes(reason.code));
        toReturn.isDevicePotentiallyLocked = toReturn.deviceLockStatus === 'POTENTIALLY_LOCKED';
        toReturn.isIncompatible = toReturn.denialReasons.some((reason: EligibilityReason) => BYOD_INCOMPATIBLE_CODES.includes(reason.code));
        toReturn.isUpdateSoftwareCompatible = toReturn.denialReasons.some((reason: EligibilityReason) => BYOD_SOFTWARE_INCOMPATIBLE_CODES.includes(reason.code));
        toReturn.isLostStolen = toReturn.denialReasons.some((reason: EligibilityReason) => reason.code === BYOD_LOST_STOLEN_CODE);
        toReturn.isDeviceEligibilityError = toReturn.deviceEligibilityResult === ByodEligibleStatus.ERROR;

        /* eslint-disable @typescript-eslint/no-explicit-any */
        return <T><any>toReturn;
        /* eslint-enable @typescript-eslint/no-explicit-any */
    }

}  